(function () {
  var trigger = document.querySelector('.redrop-badge__trigger');
  var modal = document.getElementById('redrop-modal');
  if (!trigger || !modal) return;

  var overlay = modal.querySelector('.redrop-modal__overlay');
  var closeBtn = modal.querySelector('.redrop-modal__close');
  var addToCartBtn = document.getElementById('redrop-add-to-cart');
  var colorBtns = modal.querySelectorAll('.redrop-modal__color-btn');
  var allCards = modal.querySelectorAll('.redrop-modal__card');
  var hasColorPicker = colorBtns.length > 0;

  var selectedColor = null;
  var selectedVariantId = null;

  // ─── Color picker ───────────────────────────────────────────────────────────

  function selectColor(color) {
    selectedColor = color;
    selectedVariantId = null;
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Add to Cart';

    colorBtns.forEach(function (btn) {
      btn.classList.toggle('redrop-modal__color-btn--selected', btn.dataset.color === color);
    });

    allCards.forEach(function (card) {
      var matchesColor = !card.dataset.color || card.dataset.color === color;
      card.style.display = matchesColor ? '' : 'none';
      card.classList.remove('redrop-modal__card--selected');
    });

    // Auto-select if only one available card for this color
    var available = Array.prototype.filter.call(allCards, function (c) {
      return c.dataset.color === color && !c.disabled && c.dataset.variantId;
    });
    if (available.length === 1) selectCard(available[0]);
  }

  // ─── Condition card ─────────────────────────────────────────────────────────

  function selectCard(card) {
    if (card.disabled || !card.dataset.variantId) return;

    allCards.forEach(function (c) {
      if (!c.dataset.color || c.dataset.color === selectedColor) {
        c.classList.toggle('redrop-modal__card--selected', c === card);
      }
    });

    selectedVariantId = card.dataset.variantId;
    addToCartBtn.disabled = false;
  }

  // ─── Initialise ─────────────────────────────────────────────────────────────

  if (hasColorPicker) {
    var preSelected = modal.querySelector('.redrop-modal__color-btn--selected');
    if (preSelected) selectedColor = preSelected.dataset.color;

    colorBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { selectColor(btn.dataset.color); });
    });
  } else {
    // No color picker — auto-select if single card
    var available = Array.prototype.filter.call(allCards, function (c) {
      return !c.disabled && c.dataset.variantId;
    });
    if (available.length === 1) selectCard(available[0]);
  }

  allCards.forEach(function (card) {
    card.addEventListener('click', function () { selectCard(card); });
  });

  // ─── Open / close ───────────────────────────────────────────────────────────

  function openModal() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    trigger.focus();
    selectedVariantId = null;
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Add to Cart';
    // Reset condition selection but keep color
    allCards.forEach(function (c) { c.classList.remove('redrop-modal__card--selected'); });
  }

  trigger.addEventListener('click', openModal);
  overlay.addEventListener('click', closeModal);
  closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  // ─── Add to cart ────────────────────────────────────────────────────────────

  addToCartBtn.addEventListener('click', async function () {
    if (!selectedVariantId || selectedVariantId.charAt(0) === 'p') return; // ignore preview IDs
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding...';

    // Build line item properties from the selected card
    var selectedCard = modal.querySelector('.redrop-modal__card--selected');
    var properties = { 'Pre-owned': 'Yes' };
    if (selectedCard && selectedCard.dataset.condition) {
      properties['Condition'] = selectedCard.dataset.condition;
    }

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(selectedVariantId, 10), quantity: 1, properties: properties }] })
      });

      if (res.ok) {
        addToCartBtn.textContent = 'Added!';

        // Fetch updated cart, then attach rendered section HTML so the
        // CartDrawer can refresh its contents and open automatically
        var cartRes = await fetch('/cart.js');
        var cart = await cartRes.json();

        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) {
          var sectionEl = drawerEl.closest('.shopify-section');
          var sectionId = sectionEl && sectionEl.id ? sectionEl.id.replace('shopify-section-', '') : null;
          if (sectionId) {
            var sectionHtml = await (await fetch(Shopify.routes.root + '?section_id=' + sectionId)).text();
            cart.sections = {};
            cart.sections[sectionId] = sectionHtml;
          }
        }

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart: cart }
        }));

        setTimeout(closeModal, 1000);
      } else {
        var errData = await res.json().catch(function () { return {}; });
        console.error('[ReDrop] Add to cart failed:', res.status, errData);
        addToCartBtn.textContent = 'Error — try again';
        addToCartBtn.disabled = false;
      }
    } catch (err) {
      console.error('[ReDrop] Add to cart error:', err);
      addToCartBtn.textContent = 'Error — try again';
      addToCartBtn.disabled = false;
    }
  });
})();
